export default {
domainInvalid: {
  siteUnavailableTitle: "Situs Tidak Tersedia",
  siteUnavailableDesc: "Situs ini saat ini tidak tersedia.",
  contactAdmin: "Silakan hubungi administrator.",
  serverErrorTitle: "Layanan Tidak Tersedia",
  serverErrorDesc: "Gagal terhubung ke server, silakan coba lagi nanti.",
  serverErrorTip: "Koneksi akan tersambung kembali secara otomatis setelah server aktif.",
  notAuthorizedTitle: "Domain Tidak Diizinkan",
  notAuthorizedDesc: "Domain saat ini tidak diizinkan untuk mengakses layanan ini.",
  checking: "Memeriksa...",
  retry: "Coba lagi",
  reload: "Muat ulang",
  reloading: "Memuat ulang...",
  checkingDomain: "Memeriksa domain...",
  authorizedRedirecting: "Domain diizinkan, mengalihkan...",
  stillNotAuthorized: "Domain masih belum diizinkan",
  reconnecting: "Menyambungkan kembali..."
}
};
